import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg id="arrow-up" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.78887 15.964L7.08887 15.264L12.3889 9.93896L17.6889 15.264L16.9889 15.964L12.3889 11.364L7.78887 15.964Z" />
      </svg>
      ;
    </Icons>
  );
}
